export const faqData = [
  {
    id: 1,
    question:
      "Can I calculate the EMI for different types of home loans using the SBI EMI Calculator?",
    answer:
      "Yes, the calculator can be used for different home loan products offered by SBI, such as regular home loans, SBI Privilege Home Loans, and NRI Home Loans.",
  },
  {
    id: 2,
    question:
      "Does the SBI Home Loan EMI Calculator include processing fees and other hidden charges?",
    answer:
      "The calculator estimates only the EMI based on the loan amount, interest rate, and tenure. Processing fees and other charges are separate and should be checked with the bank.",
  },
  {
    id: 3,
    question:
      "Can I adjust the loan tenure or amount after calculating the EMI?",
    answer:
      "Yes, you can adjust the loan amount, tenure, and interest rate at any time to see how the changes affect your EMI and total repayment.",
  },
];
